import { stringifyStoreId } from '@libs/core';
import Cookies from 'js-cookie';

const STORE_COOKIE_NAME = 'StoreCookie';
const ONE_YEAR_IN_DAYS = 60 * 60 * 24 * 365; // setting max age to 1 year

const DEFAULT_COOKIE_OPTIONS = {
    expires: ONE_YEAR_IN_DAYS,
    secure: true,
    sameSite: 'Strict' as const,
};
export const setStoreCookie = (value: string | number) => {
    const cookieValue =
        typeof value === 'number' ? stringifyStoreId(value) : value;
    if (!cookieValue) {
        throw new Error('Invalid store ID value. Could not set cookie.');
    }

    // remove old cookie for full domain name
    Cookies.remove(STORE_COOKIE_NAME);

    const isUS =
        window.location.hostname.includes('.petsmart.com') ||
        window.location.hostname.includes('www.petsmart.com');
    const isCA =
        window.location.hostname.includes('.petsmart.ca') ||
        window.location.hostname.includes('www.petsmart.ca');

    Cookies.set(STORE_COOKIE_NAME, cookieValue, {
        ...(isUS && { domain: '.petsmart.com' }),
        ...(isCA && { domain: '.petsmart.ca' }),
        ...DEFAULT_COOKIE_OPTIONS,
    });
};
